import tmhRequest from '@/config/tmhRequest'


export default {
    searchCustomerTagCount: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customertag/searchcustomertagcount',
            method: 'post',
            params: data,
        })
    },

    searchCustomerTagByPage: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customertag/searchcustomertagbypage',
            method: 'post',
            params: data,
        })
    },

    addCustomerTag: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customertag/addcustomertag',
            method: 'post',
            params: data,
        })
    },

    editCustomerTag: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customertag/editcustomertag',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/customertag.js